export const isFlagEnabled = (
  flags: Array<string>,
  flag: string | null
): boolean => {
  if (!flag || null === flags || undefined === flags) return false;

  return flags?.indexOf(flag) > -1;
};
